import { INTEGRATIONS } from '@client/enums/integrations';
import { SALES_FEATURES } from '@client/enums/sales-features';
import { TRACKING_FEATURES } from '@client/enums/tracking-features';
import { USER_ATTRIBUTES } from '@client/enums/user-attributes';
import { USER_ROLES } from '@client/enums/user-roles';
import { USER_STATUS } from '@client/enums/user-status';

export const USER_FILTERS = {
  search: '',
  attributes: {
    addin: {
      label: USER_ATTRIBUTES.addin.label.long,
      value: USER_ATTRIBUTES.addin.id,
      enabled: false
    },
    bizcard: {
      label: USER_ATTRIBUTES.bizcard.label.long,
      value: USER_ATTRIBUTES.bizcard.id,
      enabled: false
    },
    nosync: {
      label: USER_ATTRIBUTES.nosync.label.long,
      value: USER_ATTRIBUTES.nosync.id,
      enabled: false
    },
    inactive: {
      label: USER_ATTRIBUTES.inactive.label.long,
      value: USER_ATTRIBUTES.inactive.id,
      enabled: false
    },
    unlocked: {
      label: USER_ATTRIBUTES.unlocked.label.long,
      value: USER_ATTRIBUTES.unlocked.id,
      enabled: false
    }
  },
  integrations: {
    frontapp: {
      label: INTEGRATIONS.frontapp.label.long,
      value: INTEGRATIONS.frontapp.id,
      enabled: false
    },
    hubspot: {
      label: INTEGRATIONS.hubspot.label.long,
      value: INTEGRATIONS.hubspot.id,
      enabled: false
    },
    outreach: {
      label: INTEGRATIONS.outreach.label.long,
      value: INTEGRATIONS.outreach.id,
      enabled: false
    },
    salesforce: {
      label: INTEGRATIONS.salesforce.label.long,
      value: INTEGRATIONS.salesforce.id,
      enabled: false
    },
    salesloft: {
      label: INTEGRATIONS.salesloft.label.long,
      value: INTEGRATIONS.salesloft.id,
      enabled: false
    }
  },
  sales: {
    tracking: {
      label: SALES_FEATURES.tracking.label.long,
      value: SALES_FEATURES.tracking.id,
      enabled: false
    },
    autobcc: {
      label: SALES_FEATURES.autobcc.label.long,
      value: SALES_FEATURES.autobcc.id,
      enabled: false
    }
  },
  features: {
    autotrackdocs: {
      label: TRACKING_FEATURES.autotrackdocs.label.long,
      value: TRACKING_FEATURES.autotrackdocs.id,
      enabled: false
    },
    autotrackemails: {
      label: TRACKING_FEATURES.autotrackemails.label.long,
      value: TRACKING_FEATURES.autotrackemails.id,
      enabled: false
    },
    autotracklinks: {
      label: TRACKING_FEATURES.autotracklinks.label.long,
      value: TRACKING_FEATURES.autotracklinks.id,
      enabled: false
    }
  },
  roles: {
    billing: {
      label: USER_ROLES.billing.label.long,
      value: USER_ROLES.billing.id,
      enabled: false
    },
    domainadmin: {
      label: USER_ROLES.domainadmin.label.long,
      value: USER_ROLES.domainadmin.id,
      enabled: false
    },
    marketing: {
      label: USER_ROLES.marketing.label.long,
      value: USER_ROLES.marketing.id,
      enabled: false
    },
    signatures: {
      label: USER_ROLES.signatures.label.long,
      value: USER_ROLES.signatures.id,
      enabled: false
    },
    user: {
      label: USER_ROLES.user.label.long,
      value: USER_ROLES.user.id,
      enabled: false
    }
  },
  status: {
    active: {
      label: USER_STATUS.active.label.long,
      value: USER_STATUS.active.id,
      enabled: false
    },
    inactive: {
      label: USER_STATUS.inactive.label.long,
      value: USER_STATUS.inactive.id,
      enabled: false
    }
  }
};
